import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import { EstadoDeCuentaPorSegmento } from "../entities/estado_de_cuenta_entity";

@Pipe({
    name: "dataFilter"
})
export class DataFilterPipe implements PipeTransform {

    transform(array: EstadoDeCuentaPorSegmento[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.FAC_NUM_FAC+"").indexOf((query)) > -1);
        }
        return array;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/estadoDeCuenta/estado-de-cuenta.filter.ts